import _ from 'lodash'

export function getComparedEventProperties(msg: any) {
  if (msg.type === 'integration') {
    return getComparedEventProperties.forIntegrationMsg(msg)
  }

  if (msg.type === 'integration_response') {
    return getComparedEventProperties.forIntegrationResponseMsg(msg)
  }

  return getComparedEventProperties.forEventMsg(msg)
}

getComparedEventProperties.forIntegrationMsg = (msg: any) => {
  switch (msg.integrationType) {
    case 'http_request':
      const pickedProps = ['data.url', 'data.method', 'data.body', 'data.headers']
      return _.pick(msg, pickedProps)

    default:
      const ignoredProps = ['timestamp', 'timestampMicrosecond', 'timestampMicrosecondReversed']
      return _.omit(msg, ignoredProps)
  }
}

getComparedEventProperties.forIntegrationResponseMsg = (msg: any) => {
  const ignoredProps = ['timestamp', 'timestampMicrosecond', 'timestampMicrosecondReversed']
  return _.omit(msg, ignoredProps)
}

getComparedEventProperties.forEventMsg = (msg: any) => {
  if (msg.rawEvent?.isTestModeWarning) {
    return _.pick(msg, ['rawEvent.isTestModeWarning'])
  }

  const ignoredProps = [
    'timestamp', // All
    'timestampMicrosecond', // All
    'timestampMicrosecondReversed', // All

    'rawEvent.localTimestamp', // ChatConnector
    'rawEvent.next_state_params.part_uid', // LinuxboxConnector
    'rawEvent.call_id', // LinuxboxConnector
    'rawEvent.recipient' // ChatConnector
  ]

  return _.omit(msg, ignoredProps)
}
